export default "__VITE_ASSET__B9kdve2F__"